var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobileSocialBorder = function SvgMobileSocialBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.803 1h25.343l5.804 5.803v25.343l-5.804 5.804H6.803L1 32.146V6.803L6.803 1Z",
    stroke: "#FA3079",
    strokeWidth: 2
  })));
};
export { SvgMobileSocialBorder as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCAzOSAzOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGlkPSJQb2x5Z29uIDMiIGQ9Ik02LjgwMzM4IDFMMzIuMTQ2MiAxTDM3Ljk0OTYgNi44MDMzOUwzNy45NDk2IDMyLjE0NjJMMzIuMTQ2MiAzNy45NDk2TDYuODAzMzggMzcuOTQ5NkwxIDMyLjE0NjJMMSA2LjgwMzM4TDYuODAzMzggMVoiIHN0cm9rZT0iI0ZBMzA3OSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";